import React, { useEffect, useState } from "react";
import "./styles/createProductListLayer.css";
import "@mdi/font/css/materialdesignicons.min.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import catetgoryProvider from "../apiProvider/categoryapi";
import subCategory from "../apiProvider/subcategoryapi";
// import childCategory from "../apiProvider/childcategoryapi";
import BrandApi from "../apiProvider/brand";
import Attribute from "../apiProvider/attribute";
import {
  MultiSelect,
  Select,
  TextInput,
  Button,
  ActionIcon,
  Text,
  FileButton,
  Avatar,
  Group,
  Stack,
  Tooltip,
} from "@mantine/core";
import { IconPlus, IconTrash, IconUpload, IconPhoto, IconX } from "@tabler/icons-react";
import vendorApi from "../apiProvider/vendor";
import productApi from "../apiProvider/product";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleFormProduct } from "../redux/slices/product";
import { IMAGE_BASE_URL } from "../network/apiClient";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

const CreateProductListLayer = () => {
  const dispatch = useDispatch();

  const [isMetaTagsOpen, setIsMetaTagsOpen] = useState(false);
  const [isAttributesOpen, setIsAttributesOpen] = useState(false);
  const [isDeliveryOptionOpen, setIsDeliveryOptionOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);

  const [isExpanded, setIsExpanded] = useState(true);

  const [errors, setErrors] = useState({});
  const selector = useSelector((state) => state.product);
  const [columnsCustomer, setColumnsCustomer] = useState([]);
  const [cutomerDynamicColum, setCustomerDynamicColum] = useState([]);

  const [columns, setColumns] = useState([]);
  const [wholesalerDynamicColum, setwholesalerDynamicColum] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [initialData] = useState({
    category: "",
    subCategory: "",
    // childCategory: "",
    brand: "",
    productName: "",
    productImage: [],
    additionalImages: [],
    shortDescription: "",
    slug: "",
    lowStockAlert: false,
    tagsLabel: "Select",
    refundable: "Yes",
    productStatus: "active",
    description: "",
    hsn: "",
    customerDiscunt: "",
    customerTax: "",
    taxId: "",

    wholeSalerDiscunt: "",
    wholeSalerTax: "",

    wholesalerAttribute: {
      attributeId: [],
      rowData: [],
    },
    customerAttribute: {
      attributeId: [],
      rowData: [],
    },

    metaTitle: "",
    metaKey: "",
    metaDescription: "",

    selectDeliveryOption: "",

    vendorNameSelect: "",

    isApplicableToCustomer: false,
    isApplicableToWholesaler: false,
    lowStockQuantity: 0,
    quantityPerPack: 0,
    packingType: "",
    isIncentive: false,
    showToLineman: false,
    isTrending: false,
    isTimelessLegacy: false,
    specifications: [],
  });
  const [formData, setFormData] = useState(initialData);
  const [categoryData, setCategories] = useState([]);
  const [subCategoryData, setSubCategory] = useState([]);
  // const [childCategoryData, setchldCategory] = useState([]);
  const [brandData, setBrand] = useState([]);
  const [attributeData, setAttribute] = useState([]);
  const [vendorData, setVendor] = useState([]);

  const [taxes, setTaxes] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const productResult = await productApi.getTax();

    if (productResult.status) {
      setTaxes(productResult.response.data);
    }
  };
  const categoryDtls = async () => {
    const response = await catetgoryProvider.getCategory();

    if (response) {
      const allCategories = response?.data?.data?.items || [];
      const activeCategories = allCategories.filter(c => c.status === true);
      setCategories(activeCategories);
    }
  };

  useEffect(() => {
    const slug = formData.productName
      ?.toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9\-]/g, "")
      .replace(/\-+/g, "-")
      .replace(/^-+|-+$/g, "");

    setFormData((prev) => ({ ...prev, slug }));
  }, [formData.productName]);

  useEffect(() => {
    subCategoryDtls();
  }, [formData?.category]);

  const subCategoryDtls = async () => {
    if (!formData?.category) {
      setSubCategory([]);
      return;
    }

    setLoading(true);
    try {
      const input = {
        categoryId: formData.category,
      };
      // Use getSubCategoryByIds to fetch only matching subcategories
      const response = await subCategory.getSubCategoryByIds(input);

      if (response?.status) {
        // According to the API, getSubCategoryByIds returns `{ data: { data: [...] }}` or `{ data: [...] }`
        const items = response.response?.data?.data || response.response?.data || [];
        const activeItems = Array.isArray(items) ? items.filter(i => i.status === true) : [];
        setSubCategory(activeItems);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  /*
  useEffect(() => {
    childCategoryDtls();
  }, [formData?.subCategory]);

  const childCategoryDtls = async () => {
    if (!formData?.subCategory) {
      setchldCategory([]);
      return;
    }

    try {
      const input = {
        subcategoryId: formData.subCategory,
      };
      // Use getChildCategoryByIds to fetch only matching child categories
      const response = await childCategory.getChildCategoryByIds(input);

      if (response?.status) {
        const items = response.response?.data?.data || response.response?.data || [];
        setchldCategory(Array.isArray(items) ? items : []);
      }
    } catch (error) {
      console.error("Error in childCategoryDtls:", error);
      setchldCategory([]);
    }
  };
  */
  useEffect(() => {
    brandsDtls();
  }, [formData?.brandsDtls]);
  const brandsDtls = async () => {
    const input = {
      type: "all",
      page: 0,
      limit: 100,
    };
    const response = await BrandApi.brandList(input);

    if (response?.status) {
      setBrand(response.response.data);
    }
  };

  const attributeDtls = async () => {
    const input = {
      type: "all",
    };
    const response = await Attribute.attributeList(input);

    if (response?.status) {
      setAttribute(response.response.data);
    }
  };

  const vendorDtls = async () => {
    const input = {
      type: "all",
    };
    const response = await vendorApi.vendorList(input);

    if (response?.status) {
      setVendor(response.response.data);
    }
  };

  const getImageUrl = (img) =>
    `${IMAGE_BASE_URL}/${img.docPath}/${img.docName}`;
  const urlToFile = async (url, fileName, mimeType) => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([blob], fileName, { type: mimeType });
  };

  const setUpdatedData = async () => {
    setLoading(true);

    const response = await productApi.productDetails(selector.id);

    if (response.status) {
      const resp = response.response.data;
      console.log("DEBUG: Raw API response for product edit:", Object.keys(resp).reduce((acc, key) => {
        if (["lowStockAlert", "isTrending", "applicableForCustomer", "applicableForWholesale", "isIncentive", "showToLineman", "refundable", "productStatus"].includes(key)) {
          acc[key] = resp[key];
        }
        return acc;
      }, {}));

      /*
      const existingImages = await Promise.all(
        (resp.productImage || []).map(async (img) => {
          const url = `${IMAGE_BASE_URL}/${img.docPath}/${img.docName}`;
          return await urlToFile(
            url,
            img.originalName || img.docName,
            "image/png"
          );
        })
      );

      const additinalImag = await Promise.all(
        (resp.additionalImage || []).map(async (img) => {
          const url = `${IMAGE_BASE_URL}/${img.docPath}/${img.docName}`;
          return await urlToFile(
            url,
            img.originalName || img.docName,
            "image/png"
          );
        })
      );
      */

      setFormData({
        category: resp.categoryId || "",
        subCategory: resp.subCategory || "",
        // childCategory: resp.childCategory || "",
        brand: resp.brand || "",
        productName: resp.productName || "",
        hsn: resp.hsn || "",
        // productImage: existingImages || [],
        // additionalImages: additinalImag || [],
        shortDescription: resp.shortDescription || "",
        slug: resp.slug || "",
        lowStockAlert: resp.lowStockAlert === true || resp.lowStockAlert === "true",
        tagsLabel: resp.tagAndLabel || "Select",
        refundable: resp.refundable ? "Yes" : "No",
        productStatus: resp.productStatus ? "active" : "inactive",
        description: resp.description || "",
        lowStockQuantity: resp.lowStockQuantity || "",
        customerDiscunt: resp.customerDiscount?.toString() || "",
        customerTax: resp.customerTax?.toString() || "",
        taxId: resp.taxId || "",
        wholeSalerDiscunt: resp.wholesalerDiscount?.toString() || "",
        wholeSalerTax: resp.wholesalerTax?.toString() || "",

        wholesalerAttribute: {
          attributeId: (resp.wholesalerAttribute?.attributeId || []).map((id) => id.toString()),
          rowData: (resp.wholesalerAttribute?.rowData || []).map((row) => ({
            ...row,
            shippingWeight: row.shippingWeight || "",
            wholesalermrp: row.wholesalermrp || "",
            silver: row.silver || "",
            gold: row.gold || "",
            platinum: row.platinum || "",
          })),
        },

        customerAttribute: {
          attributeId: (resp.customerAttribute?.attributeId || []).map((id) => id.toString()),
          rowData:
            (resp.customerAttribute?.rowData || []).map((row) => ({
              ...row,
              shippingWeight: row.shippingWeight || "",
              customermrp: row.customermrp || "",
              price: row.price || "",
              dollarPrice: row.dollarPrice || "",
              images: row.images || [],
            })),
        },

        metaTitle: resp.metaTitle || "",
        metaKey: resp.metaKeyword || "",
        metaDescription: resp.metaDesc || "",

        selectDeliveryOption: resp.delivery || "",
        vendorNameSelect: resp.vendorId || "",

        isApplicableToCustomer: resp.applicableForCustomer === true || resp.applicableForCustomer === "true",
        isApplicableToWholesaler: resp.applicableForWholesale === true || resp.applicableForWholesale === "true",
        quantityPerPack: resp.quantityPerPack || 0,
        packingType: resp.packingType || "",
        isIncentive: resp.isIncentive === true || resp.isIncentive === "true",
        showToLineman: resp.showToLineman === true || resp.showToLineman === "true",
        isTrending: resp.isTrending === true || resp.isTrending === "true",
        isTimelessLegacy: resp.isTimelessLegacy === true || resp.isTimelessLegacy === "true",
        specifications: resp.specifications || [],
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([
          categoryDtls(),
          brandsDtls(),
          attributeDtls(),
          vendorDtls(),
          selector.isEdit ? setUpdatedData() : Promise.resolve(),
        ]);

        if (selector.isEdit) {
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error while fetching initial data:", error);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    if (
      selector.isEdit &&
      attributeData.length > 0 &&
      formData.customerAttribute.attributeId.length > 0
    ) {
      generateTableDataCustomer();
    }

    if (
      selector.isEdit &&
      attributeData.length > 0 &&
      formData.wholesalerAttribute.attributeId.length > 0
    ) {
      generateTableData();
    }
  }, [
    attributeData,
    formData.customerAttribute.attributeId,
    selector.isEdit,
    formData.wholesalerAttribute.attributeId,
  ]);

  const getAttributeOptions = (attributeName) => {
    const attr = attributeData.find((a) => a.name === attributeName);
    return (
      attr?.value.map((v) => {
        const img = v.images && v.images.length > 0 ? v.images[0] : null;
        return {
          value: v._id,
          label: v.value,
          image: img ? `${IMAGE_BASE_URL}/${img.docPath}/${img.docName}` : null,
        };
      }) || []
    );
  };

  const cartesian = (arrays) =>
    arrays.reduce(
      (acc, curr) =>
        acc.flatMap((a) => curr.map((b) => ({ ...a, ...b }))),
      [{}]
    );

  const generateAttributeTable = (
    attributeKey,
    setDynamicColum,
    setColumns,
    defaultRow,
    staticCols
  ) => {
    const selectedAttributes = formData[attributeKey].attributeId
      .map((id) =>
        attributeData.find((attr) => attr._id.toString() === id.toString())
      )
      .filter(Boolean);

    const attributeValues = selectedAttributes.map((attr) =>
      attr.value.map((v) => ({ [attr.name]: v._id }))
    );

    const combinations = cartesian(attributeValues);

    const shouldPreserve =
      attributeKey === "wholesalerAttribute"
        ? formData.wholesalerAttribute.rowData.length > 0 && selector.isEdit
        : formData.customerAttribute.rowData.length > 0;

    const tableRows = shouldPreserve
      ? formData[attributeKey].rowData
      : combinations.slice(0, 1).map((combo) => ({
        ...combo,
        ...defaultRow,
      }));

    const dynamicNames = selectedAttributes.map((a) => a.name);
    setDynamicColum(dynamicNames);
    setColumns([...dynamicNames, ...staticCols]);

    setFormData((prev) => ({
      ...prev,
      [attributeKey]: {
        ...prev[attributeKey],
        rowData: tableRows,
      },
    }));
  };

  const generateTableData = () => {
    generateAttributeTable(
      "wholesalerAttribute",
      setwholesalerDynamicColum,
      setColumns,
      {
        sku: "",
        stock: "",
        maxLimit: "",
        shippingWeight: "",
        wholesalermrp: "",
        silver: "",
        gold: "",
        platinum: "",
      },
      [
        "sku",
        "stock",
        "maxLimit",
        "shippingWeight",
        "wholesalermrp",
        "silver",
        "gold",
        "platinum",
      ]
    );
  };

  const handleRowChange = (rowIndex, key, value) => {
    const updated = [...formData.wholesalerAttribute.rowData];
    updated[rowIndex][key] = value;

    const rowAttrs = wholesalerDynamicColum
      .map((k) => {
        return updated[rowIndex][k];
      })
      .join("_");

    let hasConflict = false;

    for (let i = 0; i < updated.length; i++) {
      if (i !== rowIndex) {
        const compareAttrs = wholesalerDynamicColum
          .map((k) => updated[i][k])
          .join("_");

        if (
          rowAttrs === compareAttrs &&
          updated[i]["sku"] !== updated[rowIndex]["sku"]
        ) {
          hasConflict = true;
          break;
        }
      }
    }

    if (hasConflict) {
      setErrors((prev) => ({
        ...prev,
        [rowIndex]: `Duplicate combination with different SKU found.`,
      }));
    } else {
      setErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[rowIndex];
        return updatedErrors;
      });
    }

    setFormData((prev) => ({
      ...prev,
      wholesalerAttribute: {
        ...prev.wholesalerAttribute,
        rowData: updated,
      },
    }));
  };

  const handleAddRow = () => {
    const newRow = {
      sku: "",
      stock: "",
      maxLimit: "",
      shippingWeight: "",
      wholesalermrp: "",
      silver: "",
      gold: "",
      platinum: "",
    };

    setFormData((prev) => ({
      ...prev,
      wholesalerAttribute: {
        ...prev.wholesalerAttribute,
        rowData: [...prev.wholesalerAttribute.rowData, newRow],
      },
    }));
  };

  const handleRemoveRow = (rowIndex) => {
    const updatedRows = formData.wholesalerAttribute.rowData.filter(
      (_, index) => index !== rowIndex
    );
    setFormData((prev) => ({
      ...prev,
      wholesalerAttribute: {
        ...prev.wholesalerAttribute,
        rowData: updatedRows,
      },
    }));
  };

  const getAttributeOptionsCustomer = (attributeName) => {
    const attr = attributeData.find((a) => a.name === attributeName);
    return (
      attr?.value.map((v) => {
        const img = v.images && v.images.length > 0 ? v.images[0] : null;
        return {
          value: v._id,
          label: v.value,
          image: img ? `${IMAGE_BASE_URL}/${img.docPath}/${img.docName}` : null,
        };
      }) || []
    );
  };

  const generateTableDataCustomer = () => {
    generateAttributeTable(
      "customerAttribute",
      setCustomerDynamicColum,
      setColumnsCustomer,
      {
        sku: "",
        stock: "",
        maxLimit: "",
        shippingWeight: "",
        customermrp: "",
        price: "",
        dollarPrice: "",
        image: "", // for UI column
        images: [], // for data
        imageFiles: [], // newly added for multiple uploads
      },

      [
        "sku",
        "stock",
        "maxLimit",
        "shippingWeight",
        "customermrp",
        "price",
        "dollarPrice",
        "image",
      ]
    );
  };

  const handleRowChangeCustomer = (rowIndex, key, value) => {
    const updated = [...formData.customerAttribute.rowData];
    updated[rowIndex][key] = value;

    const rowAttrs = cutomerDynamicColum
      .map((k) => {
        return updated[rowIndex][k];
      })
      .join("_");

    let hasConflict = false;

    for (let i = 0; i < updated.length; i++) {
      if (i !== rowIndex) {
        const compareAttrs = cutomerDynamicColum
          .map((k) => updated[i][k])
          .join("_");

        if (
          rowAttrs === compareAttrs &&
          updated[i]["sku"] !== updated[rowIndex]["sku"]
        ) {
          hasConflict = true;
          break;
        }
      }
    }

    if (hasConflict) {
      setErrors((prev) => ({
        ...prev,
        [rowIndex]: `Duplicate combination with different SKU found.`,
      }));
    } else {
      setErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[rowIndex];
        return updatedErrors;
      });
    }

    setFormData((prev) => ({
      ...prev,
      customerAttribute: {
        ...prev.customerAttribute,
        rowData: updated,
      },
    }));
  };

  const handleAddRowCustomer = () => {
    const newRow = {
      sku: "",
      stock: "",
      maxLimit: "",
      shippingWeight: "",
      customermrp: "",
      price: "",
      dollarPrice: "",
      silver: "",
      gold: "",
      platinum: "",
      image: "",
      images: [],
      imageFiles: [],
    };


    setFormData((prev) => ({
      ...prev,
      customerAttribute: {
        ...prev.customerAttribute,
        rowData: [...prev.customerAttribute.rowData, newRow],
      },
    }));
  };

  const handleRemoveRowCustomer = (rowIndex) => {
    const updatedRows = formData.customerAttribute.rowData.filter(
      (_, index) => index !== rowIndex
    );
    setFormData((prev) => ({
      ...prev,
      customerAttribute: {
        ...prev.customerAttribute,
        rowData: updatedRows,
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCheckBox = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e, key) => {
    const files = Array.from(e.target.files);
    const allowedTypes = ["image/jpeg", "image/png"];

    const validFiles = files.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        alert(`File ${file.name} is not a valid JPG or PNG image.`);
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    setFormData((prev) => ({
      ...prev,
      [key]:
        key === "productImage"
          ? [validFiles[0]]
          : [...(prev[key] || []), ...validFiles],
    }));
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();

    setFormData((prev) => ({
      ...prev,
      description: data,
    }));
  };

  const Validate = () => {
    const newErrors = {};

    const checkRequired = (val, key, msg) => {
      if (
        !val ||
        (typeof val === "string" && !val.trim()) ||
        (Array.isArray(val) && val.length === 0)
      ) {
        newErrors[key] = msg;
      }
    };


    // Basic validations
    checkRequired(formData.category, "category", "Category is Required");
    checkRequired(
      formData.subCategory,
      "subCategory",
      "Sub Category is Required"
    );
    // checkRequired(
    //   formData.childCategory,
    //   "childCategory",
    //   "Child Category is Required"
    // );
    checkRequired(formData.brand, "brand", "Brand is Required");
    checkRequired(
      formData.productName,
      "productName",
      "Product Name is Required"
    );
    checkRequired(formData.slug, "slug", "Slug is Required");

    // Check if at least one attribute is selected

    if (
      formData.customerAttribute.attributeId.length === 0
    ) {
      newErrors["customerAttribute"] =
        "Please select at least one customer attribute";
    }

    // Product image validation (on creation only)
    if (!isEditing) {
      if (!formData.productImage || formData.productImage.length === 0) {
        newErrors["productImage"] = "At least one product image is required";
      }
    }

    // HSN validation
    if (!formData.hsn) {
      newErrors.hsn = "HSN code is required";
    } else if (!/^\d+$/.test(formData.hsn)) {
      newErrors.hsn = "HSN code must be numeric";
    } else if (![4, 6, 8].includes(formData.hsn.length)) {
      newErrors.hsn = "HSN code must be 4, 6, or 8 digits";
    }

    // Packing info validation
    checkRequired(
      formData.packingType,
      "packingType",
      "Packing Type is Required"
    );

    if (!formData.quantityPerPack) {
      newErrors.quantityPerPack = "Quantity Per Pack is Required";
    } else {
      const qty = Number(formData.quantityPerPack);
      if (isNaN(qty)) {
        newErrors.quantityPerPack = "Quantity must be a number";
      } else if (qty <= 0) {
        newErrors.quantityPerPack = "Quantity must be greater than 0";
      }
    }

    // Customer attribute table validation
    if (
      formData.customerAttribute.rowData.length > 0
    ) {
      const customerFields = [
        { field: "sku", label: "SKU" },
        { field: "stock", label: "Stock", isNum: true },
        { field: "maxLimit", label: "Max Limit", isNum: true },
        { field: "shippingWeight", label: "Shipping Weight", isNum: true },
        { field: "customermrp", label: "Customer MRP", isNum: true },
        { field: "price", label: "Price", isNum: true },
        { field: "dollarPrice", label: "Dollar Price", isNum: true },
      ];

      formData.customerAttribute.rowData.forEach((row, rowIndex) => {
        // Validate all fields
        customerFields.forEach(({ field, label, isNum }) => {
          const value = row[field];
          if (!value || value.toString().trim() === "") {
            newErrors[`customer_${field}_${rowIndex}`] = `${label} is required`;
          } else if (isNum && isNaN(Number(value))) {
            newErrors[`customer_${field}_${rowIndex}`] = `${label} must be a number`;
          } else if (isNum && Number(value) < 0) {
            newErrors[`customer_${field}_${rowIndex}`] = `${label} cannot be negative`;
          }
        });

        // Specific MRP check
        if (
          row.customermrp &&
          row.price &&
          Number(row.customermrp) <= Number(row.price)
        ) {
          newErrors[`customer_mrp_${rowIndex}`] = `Customer MRP must be greater than Price`;
        }

        // Validate dynamic attribute columns
        cutomerDynamicColum.forEach((col) => {
          if (!row[col] || row[col].toString().trim() === "") {
            newErrors[`customer_${col}_${rowIndex}`] = `${col} is required`;
          }
        });

        // Validate customer variant image (must have either newly selected file or existing image)
        const hasNewImage = row.imageFiles && row.imageFiles.length > 0;
        const hasExistingImage = row.images && row.images.length > 0;
        if (!hasNewImage && !hasExistingImage) {
          newErrors[`customer_image_${rowIndex}`] = "Variant image is required";
        }
      });
    } else {
      newErrors["customerAttributeTable"] =
        "Please generate and fill customer attribute table";
    }

    console.log("Validation errors:", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    dispatch(
      handleFormProduct({
        view: false,
        isEdit: false,
        id: "",
      })
    );
    setFormData({
      category: "",
      subCategory: "",
      // childCategory: "",
      brand: "",
      productName: "",
      productImage: [],
      additionalImages: [],
      shortDescription: "",
      slug: "",
      hsn: "",
      lowStockAlert: false,
      tagsLabel: "Select",
      refundable: "Yes",
      productStatus: "Active",
      description: "",
      customerDiscunt: "",
      customerTax: "",
      taxId: "",

      wholeSalerDiscunt: "",
      wholeSalerTax: "",

      quantityPerPack: 0,
      packingType: "",

      wholesalerAttribute: {
        attributeId: [],
        rowData: [],
      },
      customerAttribute: {
        attributeId: [],
        rowData: [],
      },

      metaTitle: "",
      metaKey: "",
      metaDescription: "",

      selectDeliveryOption: "",

      vendorNameSelect: "",

      isApplicableToCustomer: false,
      isApplicableToWholesaler: false,
      lowStockQuantity: 0,
      specifications: [],
    });
    navigate("/product");
  };

  const handleSubmit = async (e) => {
    console.log("Submitting form data:", formData);
    e.preventDefault();
    console.log("Validating form data...");
    const isvalidated = Validate();
    console.log("isvalidated", isvalidated);
    if (isvalidated) {
      console.log("Validation passed");
      if (!isEditing) {
        const formDataToSend = new FormData();

        formDataToSend.append("categoryId", formData.category);
        formDataToSend.append("subCategory", formData.subCategory);
        // formDataToSend.append("childCategory", formData.childCategory);
        formDataToSend.append("productName", formData.productName);
        formDataToSend.append("brand", formData.brand);
        formDataToSend.append("shortDescription", formData.shortDescription);
        formDataToSend.append("slug", formData.slug);
        formDataToSend.append("hsn", formData.hsn);

        /*
        if (formData.productImage) {
          formData.productImage.forEach((img) => {
            formDataToSend.append("productImage", img);
          });
        }

        if (
          formData.additionalImages &&
          Array.isArray(formData.additionalImages)
        ) {
          formData.additionalImages.forEach((img) => {
            formDataToSend.append("additionalImages", img);
          });
        }
        */

        formDataToSend.append(
          "lowStockAlert",
          formData.lowStockAlert ? "true" : ""
        );
        formDataToSend.append("tagAndLabel", formData.tagsLabel);
        formDataToSend.append(
          "refundable",
          (formData.refundable === "Yes" || formData.refundable === true) ? "true" : ""
        );
        formDataToSend.append(
          "productStatus",
          String(formData.productStatus === "active")
        );
        formDataToSend.append("description", formData.description);

        formDataToSend.append(
          "applicableForCustomer",
          "true"
        );

        formDataToSend.append(
          "customerDiscount",
          String(Number(formData.customerDiscunt))
        );
        formDataToSend.append(
          "customerTax",
          String(Number(formData.customerTax))
        );
        formDataToSend.append("taxId", formData.taxId);

        formDataToSend.append(
          "applicableForWholesale",
          formData.isApplicableToWholesaler ? "true" : ""
        );

        formDataToSend.append(
          "wholesalerDiscount",
          String(Number(formData.wholeSalerDiscunt))
        );
        formDataToSend.append(
          "wholesalerTax",
          String(Number(formData.wholeSalerTax))
        );

        formDataToSend.append(
          "wholesalerAttribute",
          JSON.stringify(formData.wholesalerAttribute)
        );
        const customerAttributeData = {
          ...formData.customerAttribute,
          rowData: formData.customerAttribute.rowData.map(row => {
            const { imageFile, imageFiles, ...rest } = row;
            return rest;
          })
        };

        formData.customerAttribute.rowData.forEach((row, index) => {
          if (row.imageFiles && row.imageFiles.length > 0) {
            row.imageFiles.forEach((file) => {
              formDataToSend.append(`customerAttributeImage_${index}`, file);
            });
          }
        });

        formDataToSend.append(
          "customerAttribute",
          JSON.stringify(customerAttributeData)
        );

        formDataToSend.append("metaTitle", formData.metaTitle);
        formDataToSend.append("metaKeyword", formData.metaKey);
        formDataToSend.append("metaDesc", formData.metaDescription);

        formDataToSend.append("delivery", formData.selectDeliveryOption);
        formDataToSend.append("lowStockQuantity", formData.lowStockQuantity);
        formDataToSend.append("quantityPerPack", formData.quantityPerPack);
        formDataToSend.append("packingType", formData.packingType);
        formDataToSend.append("isIncentive", formData.isIncentive ? "true" : "");
        formDataToSend.append("showToLineman", formData.showToLineman ? "true" : "");
        formDataToSend.append("isTrending", formData.isTrending ? "true" : "false");
        formDataToSend.append("isTimelessLegacy", formData.isTimelessLegacy ? "true" : "false");
        formDataToSend.append(
          "specifications",
          JSON.stringify(formData.specifications)
        );
        console.log("formDataToSend", formDataToSend);

        const response = await productApi.productcreate(formDataToSend);
        if (response.status) {
          handleClose();
        } else {
          // Show slug or other backend errors in the form
          const errMsg = response.error || 'Failed to create product. Please try again.';
          if (errMsg.toLowerCase().includes('slug')) {
            setErrors((prev) => ({ ...prev, slug: 'Slug already exists. Please use a different slug.' }));
          } else {
            setErrors((prev) => ({ ...prev, submit: errMsg }));
          }
        }
      }

      if (isEditing) {
        const formDataToSend = new FormData();
        formDataToSend.append("categoryId", formData.category);
        formDataToSend.append("subCategory", formData.subCategory);
        // formDataToSend.append("childCategory", formData.childCategory);
        formDataToSend.append("productName", formData.productName);
        formDataToSend.append("brand", formData.brand);
        formDataToSend.append("shortDescription", formData.shortDescription);
        formDataToSend.append("slug", formData.slug);
        formDataToSend.append("hsn", formData.hsn);

        /*
        if (formData.productImage) {
          formData.productImage.forEach((img) => {
            if (img instanceof File) {
              formDataToSend.append("productImage", img);
            }
          });
        }

        if (
          formData.additionalImages &&
          Array.isArray(formData.additionalImages)
        ) {
          formData.additionalImages.forEach((img) => {
            formDataToSend.append("additionalImages", img);
          });
        }
        */

        formDataToSend.append(
          "lowStockAlert",
          formData.lowStockAlert ? "true" : ""
        );
        formDataToSend.append("tagAndLabel", formData.tagsLabel);
        formDataToSend.append(
          "refundable",
          (formData.refundable === "Yes" || formData.refundable === true) ? "true" : ""
        );
        formDataToSend.append(
          "productStatus",
          String(formData.productStatus === "active")
        );
        formDataToSend.append("description", formData.description);

        formDataToSend.append(
          "applicableForCustomer",
          "true"
        );

        formDataToSend.append(
          "customerDiscount",
          String(Number(formData.customerDiscunt))
        );
        formDataToSend.append(
          "customerTax",
          String(Number(formData.customerTax))
        );
        formDataToSend.append("taxId", formData.taxId);

        const customerAttributeData = {
          ...formData.customerAttribute,
          rowData: formData.customerAttribute.rowData.map(row => {
            const { imageFile, imageFiles, ...rest } = row;
            return rest;
          })
        };

        formData.customerAttribute.rowData.forEach((row, index) => {
          if (row.imageFiles && row.imageFiles.length > 0) {
            row.imageFiles.forEach((file) => {
              formDataToSend.append(`customerAttributeImage_${index}`, file);
            });
          }
        });

        formDataToSend.append(
          "customerAttribute",
          JSON.stringify(customerAttributeData)
        );

        formDataToSend.append("metaTitle", formData.metaTitle);
        formDataToSend.append("metaKeyword", formData.metaKey);
        formDataToSend.append("metaDesc", formData.metaDescription);
        formDataToSend.append("delivery", formData.selectDeliveryOption);
        formDataToSend.append("lowStockQuantity", formData.lowStockQuantity);
        formDataToSend.append("quantityPerPack", formData.quantityPerPack);
        formDataToSend.append("packingType", formData.packingType);
        formDataToSend.append("isIncentive", formData.isIncentive ? "true" : "");
        formDataToSend.append("showToLineman", formData.showToLineman ? "true" : "");
        formDataToSend.append("isTrending", formData.isTrending ? "true" : "false");
        formDataToSend.append("isTimelessLegacy", formData.isTimelessLegacy ? "true" : "false");
        formDataToSend.append(
          "specifications",
          JSON.stringify(formData.specifications)
        );

        formDataToSend.append("id", selector.id);
        const response = await productApi.updateproduct(
          formDataToSend,
          selector.id
        );

        if (response.status) {
          handleClose();
        } else {
          // Show slug or other backend errors in the form
          const errMsg = response.error || 'Failed to update product. Please try again.';
          if (errMsg.toLowerCase().includes('slug')) {
            setErrors((prev) => ({ ...prev, slug: 'Slug already exists. Please use a different slug.' }));
          } else {
            setErrors((prev) => ({ ...prev, submit: errMsg }));
          }
        }
      }
    } else {
      setTimeout(() => {
        const errorElement = document.querySelector(".is-invalid, div.text-danger");
        if (errorElement) {
          // Check which accordion the error is inside to open it
          const cardParent = errorElement.closest('.card');
          if (cardParent) {
            const cardText = cardParent.textContent || "";
            if (cardText.includes('General Info') && !isExpanded) setIsExpanded(true);
            if (cardText.includes('Attributes') && !isAttributesOpen) setIsAttributesOpen(true);
            if (cardText.includes('Product Meta Tags') && !isMetaTagsOpen) setIsMetaTagsOpen(true);
            // if (cardText.includes('Images') && !imageOpen) setImageOpen(true);
          }

          // Re-query after potentially opening the accordion to ensure it scrolls correctly
          setTimeout(() => {
            errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            const inputToFocus = errorElement.tagName === "INPUT" || errorElement.tagName === "SELECT" || errorElement.tagName === "TEXTAREA"
              ? errorElement
              : errorElement.parentElement?.querySelector("input, select, textarea");
            if (inputToFocus) inputToFocus.focus();
          }, 150);
        }
      }, 100);
    }
  };

  const handleDeleteImage = (indexToRemove) => {
    setFormData((prevData) => ({
      ...prevData,
      productImage: prevData.productImage.filter((_, i) => i !== indexToRemove),
    }));
  };

  const handleDeleteAdditionalImage = (indexToRemove) => {
    setFormData((prevData) => ({
      ...prevData,
      additionalImages: prevData.additionalImages.filter(
        (_, i) => i !== indexToRemove
      ),
    }));
  };

  const formatHeaderName = (header) => {
    const specialCases = {
      sku: "SKU",
      stock: "Stock",
      maxlimit: "Max Limit",
      shippingweight: "Shipping Weight",
      wholesalermrp: "Wholesaler MRP",
      silver: "Silver Price",
      gold: "Gold Price",
      platinum: "Platinum Price",
      price: "Price",
      customermrp: "Customer MRP",
      dollarprice: "SGD Price ($)",
    };

    const lowerHeader = header.toLowerCase();
    if (specialCases[lowerHeader]) {
      return specialCases[lowerHeader];
    }

    return header
      .split(/(?=[A-Z])/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (isLoading) {
    return <>Loading....</>;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div id="addproduct-accordion" className="custom-accordion">
              {/* General Info Section */}
              <div className="card mb-4">
                <a
                  href="#addproduct-productinfo-collapse"
                  className={`text-body ${isExpanded ? "" : "collapsed"}`}
                  data-bs-toggle="collapse"
                  aria-expanded={isExpanded}
                  aria-controls="addproduct-productinfo-collapse"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsExpanded(!isExpanded);
                  }}
                >
                  <div className="p-4">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar">
                          <div className="avatar-title custom-avatar rounded-circle bg-primary-subtle text-primary d-flex justify-content-center align-items-center">
                            <h5 className="text-primary font-size-17 mb-0">
                              01
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 overflow-hidden">
                        <h5 className="font-size-16 mb-1">General Info</h5>
                        <p className="text-muted text-truncate mb-0">
                          Fill all information below
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <i
                          className={`mdi mdi-chevron-${isExpanded ? "up" : "down"
                            } accor-down-icon font-size-24`}
                        ></i>
                      </div>
                    </div>
                  </div>
                </a>

                <div
                  id="addproduct-productinfo-collapse"
                  className={`collapse ${isExpanded ? "show" : ""}`}
                  data-bs-parent="#addproduct-accordion"
                >
                  <div className="p-4 border-top">
                    <form>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="category">
                              Category <span className="text-danger">*</span></label>
                            <select
                              id="category"
                              name="category"
                              className="form-control"
                              value={formData.category}
                              onChange={(e) => {
                                handleChange(e);
                                categoryDtls(e.target.value);
                              }}
                            >
                              <option value="">Select Category</option>
                              {categoryData?.map((cat) => (
                                <option key={cat._id} value={cat._id}>
                                  {cat.name}
                                </option>
                              ))}
                            </select>
                            {errors.category && (
                              <div className="text-danger">
                                {errors.category}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="subCategory">
                              Sub Category <span className="text-danger">*</span></label>
                            <select
                              id="subCategory"
                              name="subCategory"
                              className="form-control"
                              value={formData.subCategory}
                              onChange={(e) => {
                                handleChange(e);
                                // childCategoryDtls(e.target.value);
                              }}
                            >
                              <option value="">Select Sub Category</option>
                              {subCategoryData?.map((sub) => (
                                <option key={sub._id} value={sub._id}>
                                  {sub.name}
                                </option>
                              ))}
                            </select>
                            {errors.subCategory && (
                              <div className="text-danger">
                                {errors.subCategory}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-lg-4">
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="childCategory"
                            >
                              Child Category
                            </label>
                            <select
                              id="childCategory"
                              name="childCategory"
                              className="form-control"
                              value={formData.childCategory}
                              onChange={handleChange}
                              styles={{
                                option: (provided) => ({
                                  ...provided,
                                  height: "100px",
                                  padding: "10px",
                                }),
                              }}
                            >
                              <option value="">Select Child Category</option>
                              {childCategoryData?.map((child) => (
                                <option key={child._id} value={child._id}>
                                  {child.name}
                                </option>
                              ))}
                            </select>
                            {errors.childCategory && (
                              <div className="text-danger">
                                {errors.childCategory}
                              </div>
                            )}
                          </div>
                        </div> */}
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="brand">
                              Brand <span className="text-danger">*</span></label>
                            <select
                              id="brand"
                              name="brand"
                              className="form-select"
                              value={formData.brand}
                              onChange={handleChange}
                            >
                              <option value="">Select Brand</option>
                              {brandData?.map((bramd) => (
                                <option key={bramd._id} value={bramd._id}>
                                  {bramd.name}
                                </option>
                              ))}
                            </select>
                            {errors.brand && (
                              <div className="text-danger">{errors.brand}</div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">


                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="productName">
                              Product name <span className="text-danger">*</span></label>
                            <input
                              id="productName"
                              name="productName"
                              type="text"
                              className="form-control"
                              value={formData.productName}
                              onChange={handleChange}
                            />
                            {errors.productName && (
                              <div className="text-danger">
                                {errors.productName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label
                              htmlFor="shortDescription"
                              className="form-label"
                            >
                              Short Description
                            </label>
                            <textarea
                              id="shortDescription"
                              name="shortDescription"
                              className="form-control"
                              rows="1"
                              value={formData.shortDescription}
                              onChange={handleChange}
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="slug">
                              Slug <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className="form-control"
                              name="slug"
                              value={formData.slug}
                              onChange={handleChange}
                            />

                            {errors.slug && (
                              <div className="text-danger">{errors.slug}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="mb-3">
                            <label htmlFor="packingType" className="form-label">
                              Packing Type <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              id="packingType"
                              name="packingType"
                              value={formData.packingType}
                              onChange={handleChange}
                            >
                              <option value="">Select Packing Type</option>
                              <option value="Bag">Bag</option>
                              <option value="Box">Box</option>
                            </select>
                            {errors.packingType && (
                              <div className="text-danger">
                                {errors.packingType}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="mb-3">
                            <label
                              htmlFor="quantityPerPack"
                              className="form-label"
                            >
                              Quantity Per Pack (Bag/Box) <span className="text-danger">*</span></label>
                            <input
                              type="number"
                              className="form-control"
                              id="quantityPerPack"
                              name="quantityPerPack"
                              value={formData.quantityPerPack}
                              onChange={handleChange}
                              min={0}
                            />

                            {errors.quantityPerPack && (
                              <div className="text-danger">
                                {errors.quantityPerPack}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="Hsn">
                              HSN Code <span className="text-danger">*</span></label>
                            <input
                              id=""
                              name="hsn"
                              type="text"
                              className="form-control"
                              value={formData.hsn}
                              onChange={handleChange}
                            />
                            {errors.hsn && (
                              <div className="text-danger">{errors.hsn}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="mb-3">
                            <label htmlFor="tagsLabel" className="form-label">
                              Tags &amp; Label
                            </label>
                            <select
                              id="tagsLabel"
                              className="form-select"
                              name="tagsLabel"
                              value={formData.tagsLabel}
                              onChange={handleChange}
                            >
                              <option>Select</option>
                              <option>Best Seller</option>
                              <option>New Arrival</option>
                              <option>Top Rated</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="mb-3">
                            <label htmlFor="refundable" className="form-label">
                              Refundable
                            </label>
                            <select
                              className="form-select"
                              id="refundable"
                              aria-label="Refundable select"
                              name="refundable"
                              value={formData.refundable}
                              onChange={handleChange}
                            >
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="mb-3">
                            <label
                              htmlFor="productStatus"
                              className="form-label"
                            >
                              Product Status
                            </label>
                            <select
                              className="form-select"
                              id="productStatus"
                              aria-label="Product status select"
                              name="productStatus"
                              value={formData.productStatus}
                              onChange={handleChange}
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                              {/* Left side: Low Stock Alert */}
                              <div className="d-flex align-items-center flex-wrap gap-3">
                                <div className="d-flex align-items-center">
                                  <label
                                    htmlFor="lowStockAlert"
                                    className="form-label mb-0 me-3"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Low Stock Alert
                                  </label>
                                  <input
                                    id="lowStockAlert"
                                    name="lowStockAlert"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={formData.lowStockAlert}
                                    onChange={handleChangeCheckBox}
                                  />
                                </div>

                                {formData.lowStockAlert && (
                                  <div className="d-flex align-items-center gap-2">
                                    <label
                                      htmlFor="lowStockQuantity"
                                      className="form-label mb-0"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      Alert Quantity
                                    </label>
                                    <input
                                      id="lowStockQuantity"
                                      name="lowStockQuantity"
                                      type="number"
                                      className="form-control"
                                      value={formData.lowStockQuantity || ""}
                                      onChange={handleChange}
                                      min="1"
                                      style={{ maxWidth: "150px" }}
                                    />
                                  </div>
                                )}
                              </div>

                              {/* Right side: Trending and Timeless Legacy */}
                              <div className="d-flex align-items-center gap-4">
                                <div className="d-flex align-items-center">
                                  <label
                                    htmlFor="isTrending"
                                    className="form-label mb-0 me-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Trending Product
                                  </label>
                                  <input
                                    id="isTrending"
                                    name="isTrending"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={formData.isTrending}
                                    onChange={handleChangeCheckBox}
                                  />
                                </div>

                                <div className="d-flex align-items-center">
                                  <label
                                    htmlFor="isTimelessLegacy"
                                    className="form-label mb-0 me-2"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    Timeless Legacy
                                  </label>
                                  <input
                                    id="isTimelessLegacy"
                                    name="isTimelessLegacy"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={formData.isTimelessLegacy}
                                    onChange={handleChangeCheckBox}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Specifications Section */}
                        <div className="row mb-4">
                          <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="font-size-14 mb-0">Product Specifications (Optional)</h5>
                              <Button
                                variant="light"
                                color="blue"
                                leftSection={<IconPlus size={16} />}
                                onClick={() => {
                                  setFormData(prev => ({
                                    ...prev,
                                    specifications: [...prev.specifications, { key: "", value: "" }]
                                  }));
                                }}
                              >
                                Add Specification
                              </Button>
                            </div>

                            {formData.specifications.map((spec, index) => (
                              <div className="row align-items-center mb-2" key={index}>
                                <div className="col-5">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Specification Name (e.g. Fabric)"
                                    value={spec.key}
                                    onChange={(e) => {
                                      const newSpecs = [...formData.specifications];
                                      newSpecs[index].key = e.target.value;
                                      setFormData(prev => ({ ...prev, specifications: newSpecs }));
                                    }}
                                  />
                                </div>
                                <div className="col-5">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Value (e.g. Cotton)"
                                    value={spec.value}
                                    onChange={(e) => {
                                      const newSpecs = [...formData.specifications];
                                      newSpecs[index].value = e.target.value;
                                      setFormData(prev => ({ ...prev, specifications: newSpecs }));
                                    }}
                                  />
                                </div>
                                <div className="col-2">
                                  <ActionIcon
                                    color="red"
                                    onClick={() => {
                                      setFormData(prev => ({
                                        ...prev,
                                        specifications: prev.specifications.filter((_, i) => i !== index)
                                      }));
                                    }}
                                  >
                                    <IconTrash size={16} />
                                  </ActionIcon>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>



                      <div className="row">
                        <div className="col-xl-12">
                          <div className="card ">
                            <div className="card-header">
                              <h4 className="card-title mb-0">Description</h4>
                            </div>
                            <div className="card-body">
                              <CKEditor
                                editor={ClassicEditor}
                                data={formData.description}
                                onChange={handleEditorChange}
                                className=""
                                config={{
                                  licenseKey: "GPL",
                                  toolbar: [
                                    "undo",
                                    "redo",
                                    "heading",
                                    "|",
                                    "bold",
                                    "italic",
                                    "link",
                                    "imageUpload",
                                    "insertTable",
                                    "blockQuote",
                                    "bulletedList",
                                    "numberedList",
                                    "|",
                                    "outdent",
                                    "indent",
                                    "|",
                                  ],
                                }}
                                style={{ minHeight: "300px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* Attributes Section */}
              <div className="card">
                <div className="p-4">
                  <div
                    className="d-flex align-items-center"
                    onClick={() => setIsAttributesOpen(!isAttributesOpen)}
                  >
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar">
                        <div className="avatar-title custom-avatar rounded-circle bg-primary-subtle text-primary d-flex justify-content-center align-items-center">
                          <h5 className="text-primary font-size-17 mb-0">04</h5>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <h5 className="font-size-16 mb-1">Attributes</h5>
                      <p className="text-muted text-truncate mb-0">
                        Fill all information below
                      </p>
                    </div>
                    <div className="flex-shrink-0">
                      <i
                        className={`mdi ${isAttributesOpen
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                          } accor-down-icon font-size-24 cursor-pointer`}
                        onClick={() => setIsAttributesOpen(!isAttributesOpen)}
                      ></i>
                    </div>
                  </div>
                </div>
                {isAttributesOpen && (
                  <div className="p-4 border-top">


                    <h5 className="font-size-18 mt-5 mb-4">
                      Customer Attribute <span className="text-danger">*</span>
                    </h5>
                    <form>
                      <div className="row">
                        <div>
                          <Select
                            label="Select Attribute"
                            placeholder="Pick an attribute"
                            data={attributeData.map((attr) => ({
                              value: String(attr._id),
                              label: attr.name,
                            }))}
                            value={formData.customerAttribute.attributeId[0] || null}
                            onChange={(selected) =>
                              setFormData((prev) => ({
                                ...prev,
                                customerAttribute: {
                                  ...prev.customerAttribute,
                                  attributeId: selected ? [selected] : [],
                                },
                              }))
                            }
                            searchable
                            nothingFound="No options"
                          />
                          {errors.customerAttribute && (
                            <p className="text-danger">
                              {errors.customerAttribute}
                            </p>
                          )}
                          <Button mt="md" onClick={generateTableDataCustomer}>
                            Generate Table
                          </Button>
                          {errors.customerAttributeTable && (
                            <p className="text-danger mt-1">
                              {errors.customerAttributeTable}
                            </p>
                          )}

                          {formData.customerAttribute.rowData.length > 0 && (
                            <table className="table mt-4">
                              <thead>
                                <tr>
                                  {columnsCustomer.map((col, idx) => (
                                    <th
                                      key={idx}
                                      style={{
                                        textAlign: col === "image" ? "center" : "left",
                                        width: col === "image" ? "180px" : "auto"
                                      }}
                                    >
                                      {formatHeaderName(col)}
                                    </th>
                                  ))}
                                  <th style={{ textAlign: "center" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.customerAttribute.rowData.map(
                                  (row, rowIndex) => (
                                    <React.Fragment key={rowIndex}>
                                      <tr key={rowIndex}>
                                        {columnsCustomer.map((col) => (
                                          <td key={col} style={{ verticalAlign: "middle", padding: "4px" }}>
                                            {col === "image" ? (
                                              (() => {
                                                const combinedItems = [
                                                  ...(row.images || []).map((img, idx) => ({ type: 'existing', data: img, originalIndex: idx })),
                                                  ...(row.imageFiles || []).map((file, idx) => ({ type: 'new', data: file, originalIndex: idx }))
                                                ];

                                                const handleDragStart = (e, itemIdx) => {
                                                  e.dataTransfer.setData("text/plain", JSON.stringify({ rowIndex, itemIdx }));
                                                  e.dataTransfer.effectAllowed = "move";
                                                };

                                                const handleDragOver = (e) => {
                                                  e.preventDefault();
                                                };

                                                const handleDrop = (e, targetIdx) => {
                                                  e.preventDefault();
                                                  try {
                                                    const dataStr = e.dataTransfer.getData("text/plain");
                                                    if (!dataStr) return;
                                                    const { rowIndex: srcRowIndex, itemIdx: srcItemIdx } = JSON.parse(dataStr);
                                                    if (srcRowIndex !== rowIndex) return;
                                                    if (srcItemIdx === targetIdx) return;

                                                    const newCombined = [...combinedItems];
                                                    const [moved] = newCombined.splice(srcItemIdx, 1);
                                                    newCombined.splice(targetIdx, 0, moved);

                                                    const newImages = [];
                                                    const newImageFiles = [];

                                                    newCombined.forEach(item => {
                                                      if (item.type === 'existing') {
                                                        newImages.push(item.data);
                                                      } else {
                                                        newImageFiles.push(item.data);
                                                      }
                                                    });

                                                    handleRowChangeCustomer(rowIndex, "images", newImages);
                                                    handleRowChangeCustomer(rowIndex, "imageFiles", newImageFiles);
                                                  } catch (err) {
                                                    console.error("Error reordering images", err);
                                                  }
                                                };

                                                return (
                                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'flex-start', alignItems: 'flex-start', minHeight: '45px' }}>
                                                    {combinedItems.map((item, itemIdx) => {
                                                      if (item.type === 'existing') {
                                                        const img = item.data;
                                                        const imgIdx = item.originalIndex;
                                                        return (
                                                          <div
                                                            key={`existing-${imgIdx}-${itemIdx}`}
                                                            draggable
                                                            onDragStart={(e) => handleDragStart(e, itemIdx)}
                                                            onDragOver={handleDragOver}
                                                            onDrop={(e) => handleDrop(e, itemIdx)}
                                                            style={{
                                                              position: 'relative',
                                                              width: '45px',
                                                              height: '45px',
                                                              cursor: 'grab',
                                                              transition: 'transform 0.2s, box-shadow 0.2s',
                                                            }}
                                                            onDragEnter={(e) => { e.currentTarget.style.transform = 'scale(1.15)'; }}
                                                            onDragLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                                                            onDragEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                                                          >
                                                            <img
                                                              src={`${IMAGE_BASE_URL}/${img.docPath}/${img.docName}`}
                                                              alt="existing"
                                                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px', border: '1px solid #dee2e6', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', pointerEvents: 'none' }}
                                                            />
                                                            <ActionIcon
                                                              size="xs"
                                                              color="red"
                                                              variant="filled"
                                                              style={{
                                                                position: 'absolute',
                                                                top: -6,
                                                                right: -6,
                                                                width: '18px',
                                                                height: '18px',
                                                                borderRadius: '50%',
                                                                zIndex: 2,
                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                                              }}
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                const updatedImages = row.images.filter((_, i) => i !== imgIdx);
                                                                handleRowChangeCustomer(rowIndex, "images", updatedImages);
                                                              }}
                                                            >
                                                              <IconX size={10} />
                                                            </ActionIcon>
                                                          </div>
                                                        );
                                                      } else {
                                                        const file = item.data;
                                                        const fileIdx = item.originalIndex;
                                                        let objectUrl = "";
                                                        try {
                                                          objectUrl = URL.createObjectURL(file);
                                                        } catch (err) {
                                                          console.warn("Failed to create URL for file", file);
                                                        }
                                                        return (
                                                          <div
                                                            key={`new-${fileIdx}-${itemIdx}`}
                                                            draggable
                                                            onDragStart={(e) => handleDragStart(e, itemIdx)}
                                                            onDragOver={handleDragOver}
                                                            onDrop={(e) => handleDrop(e, itemIdx)}
                                                            style={{
                                                              position: 'relative',
                                                              width: '45px',
                                                              height: '45px',
                                                              cursor: 'grab',
                                                              transition: 'transform 0.2s, box-shadow 0.2s',
                                                            }}
                                                            onDragEnter={(e) => { e.currentTarget.style.transform = 'scale(1.15)'; }}
                                                            onDragLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                                                            onDragEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                                                          >
                                                            <img
                                                              src={objectUrl}
                                                              alt="new"
                                                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px', border: '2px solid #3b82f6', boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)', pointerEvents: 'none' }}
                                                            />
                                                            <ActionIcon
                                                              size="xs"
                                                              color="red"
                                                              variant="filled"
                                                              style={{
                                                                position: 'absolute',
                                                                top: -6,
                                                                right: -6,
                                                                width: '18px',
                                                                height: '18px',
                                                                borderRadius: '50%',
                                                                zIndex: 2,
                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                                              }}
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                const updatedFiles = row.imageFiles.filter((_, i) => i !== fileIdx);
                                                                handleRowChangeCustomer(rowIndex, "imageFiles", updatedFiles);
                                                              }}
                                                            >
                                                              <IconX size={10} />
                                                            </ActionIcon>
                                                          </div>
                                                        );
                                                      }
                                                    })}

                                                    {/* Unified Upload Button (The 'Plus' box) */}
                                                    <FileButton
                                                      onChange={(files) => {
                                                        if (files && files.length > 0) {
                                                          const currentFiles = row.imageFiles || [];
                                                          handleRowChangeCustomer(rowIndex, "imageFiles", [...currentFiles, ...files]);
                                                        }
                                                      }}
                                                      accept="image/png,image/jpeg"
                                                      multiple
                                                    >
                                                      {(props) => (
                                                        <div
                                                          {...props}
                                                          style={{
                                                            width: '45px',
                                                            height: '45px',
                                                            border: '1px dashed #3b82f6',
                                                            borderRadius: '6px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            backgroundColor: '#eff6ff',
                                                            color: '#3b82f6',
                                                            transition: 'all 0.2s'
                                                          }}
                                                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#dbeafe'; e.currentTarget.style.borderColor = '#2563eb'; }}
                                                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#eff6ff'; e.currentTarget.style.borderColor = '#3b82f6'; }}
                                                          title="Click to add more images"
                                                        >
                                                          <IconPlus size={20} />
                                                        </div>
                                                      )}
                                                    </FileButton>
                                                  </div>
                                                );
                                              })()
                                            ) : [
                                              "sku",
                                              "stock",
                                              "maxLimit",
                                              "shippingWeight",
                                              "customermrp",
                                              "price",
                                              "dollarPrice",
                                            ].includes(col)
                                              ? (
                                                <TextInput
                                                  value={row[col]}
                                                  onChange={(e) =>
                                                    handleRowChangeCustomer(
                                                      rowIndex,
                                                      col,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              ) : (
                                                (() => {
                                                  const options = getAttributeOptionsCustomer(col);
                                                  const selectedOption = options.find(opt => String(opt.value) === String(row[col] || ""));
                                                  return (
                                                    <Select
                                                      data={options}
                                                      value={row[col] ? String(row[col]) : ""}
                                                      onChange={(value) =>
                                                        handleRowChangeCustomer(
                                                          rowIndex,
                                                          col,
                                                          value
                                                        )
                                                      }
                                                      searchable
                                                      renderOption={({ option, checked }) => (
                                                        <Group gap="sm" wrap="nowrap">
                                                          {option.image ? (
                                                            <div style={{ width: 24, height: 24, borderRadius: 4, overflow: 'hidden', border: '1px solid #ced4da' }}>
                                                              <img src={option.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                            </div>
                                                          ) : (
                                                            <div style={{ width: 24, height: 24, borderRadius: 4, backgroundColor: '#f8f9fa', border: '1px solid #ced4da' }} title="No image available" />
                                                          )}
                                                          <Text size="sm">{option.label}</Text>
                                                        </Group>
                                                      )}
                                                      leftSection={selectedOption?.image && (
                                                        <div style={{ width: 18, height: 18, borderRadius: 3, overflow: 'hidden', border: '1px solid #ced4da', marginLeft: 4 }}>
                                                          <img src={selectedOption.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                        </div>
                                                      )}
                                                    />
                                                  );
                                                })()
                                              )}
                                          </td>
                                        ))}
                                        <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                          <div className="d-flex justify-content-center gap-2">
                                            <ActionIcon
                                              color="green"
                                              onClick={handleAddRowCustomer}
                                            >
                                              <IconPlus size={20} />
                                            </ActionIcon>
                                            <ActionIcon
                                              color="red"
                                              onClick={() =>
                                                handleRemoveRowCustomer(rowIndex)
                                              }
                                            >
                                              <IconTrash size={20} />
                                            </ActionIcon>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan={columnsCustomer.length + 1}>
                                          {/* Display all errors for this row */}
                                          {Object.keys(errors).map((key) => {
                                            if (
                                              key.startsWith(`customer_`) &&
                                              key.endsWith(`_${rowIndex}`)
                                            ) {
                                              return (
                                                <p
                                                  key={key}
                                                  className="text-danger"
                                                  size="sm"
                                                  style={{ display: "block" }}
                                                >
                                                  {errors[key]}
                                                </p>
                                              );
                                            }
                                            return null;
                                          })}
                                          {errors[rowIndex] && (
                                            <p
                                              size="sm"
                                              className="text-danger"
                                            >
                                              {errors[rowIndex]}
                                            </p>
                                          )}
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  )
                                )}
                              </tbody>
                            </table>
                          )}
                          <div className="row mt-3">
                            <div className="col-lg-6 mb-3">
                              <label className="form-label">
                                Discount (if applicable)
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="customerDiscunt"
                                value={formData.customerDiscunt}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-lg-6 mb-3">
                              <label className="form-label">Tax %</label>
                              <select
                                className="form-control"
                                name="taxId"
                                value={formData.taxId}
                                onChange={handleChange}
                                style={{ width: "99.5%" }}
                              >
                                <option value="">Select</option>
                                {taxes
                                  .filter((tax) => tax.isActive)
                                  .map((tax) => (
                                    <option key={tax._id} value={tax._id}>
                                      {tax.taxName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>

              {/* Meta Tags Section */}
              <div className="card mb-4">
                <div
                  className="text-body collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#meta-tags-collapse"
                  aria-expanded={isMetaTagsOpen}
                  aria-controls="meta-tags-collapse"
                  onClick={() => setIsMetaTagsOpen(!isMetaTagsOpen)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="p-16">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar">
                          <div className="avatar-title custom-avatar rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
                            <h5 className="text-primary font-size-17 mb-0">
                              05
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 custom-title overflow-hidden">
                        <h5 className="font-size-16 mb-1">Product Meta Tags</h5>
                        <p className="text-muted text-truncate mb-0">
                          Fill all information below
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <i
                          className={`mdi ${isMetaTagsOpen
                            ? "mdi-chevron-up"
                            : "mdi-chevron-down"
                            } accor-down-icon font-size-24`}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="meta-tags-collapse"
                  className={`collapse ${isMetaTagsOpen ? "show" : ""}`}
                  data-bs-parent="#meta-tags-accordion"
                >
                  <div className="p-16 border-top">
                    <form>
                      <div className="row">
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">Meta Title</label>
                          <input
                            type="text"
                            name="metaTitle"
                            value={formData.metaTitle}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>

                        <div className="col-lg-12 mb-3">
                          <label className="form-label">Meta Keywords</label>
                          <input
                            type="text"
                            name="metaKey"
                            value={formData.metaKey}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label className="form-label">Meta Description</label>
                          <textarea
                            className="form-control"
                            rows="4"
                            name="metaDescription"
                            value={formData.metaDescription}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* 
              <div className="card mb-4">
                <a
                  onClick={() => setImageOpen(!imageOpen)}
                  className={`text-body collbodyd ${imageOpen ? "" : "collapsed"
                    }`}
                  aria-haspopup="true"
                  aria-expanded={imageOpen}
                  aria-controls="addproduct-manufacturer-collapse"
                >
                  <div className="p-4">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar">
                          <div className="avatar-title custom-avatar rounded-circle bg-primary-subtle text-primary d-flex justify-content-center align-items-center">
                            <h5 className="text-primary font-size-17 mb-0">
                              06
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1 overflow-hidden">
                        <h5 className="font-size-16 mb-1">Images</h5>
                        <p className="text-muted text-truncate mb-0">
                          Fill all images
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        <i
                          className={`mdi accor-down-icon font-size-24 ${imageOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                            }`}
                        ></i>
                      </div>
                    </div>
                  </div>
                </a>

                {imageOpen && (
                  <div className="p-4 border-top">
                    <form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <label
                                  htmlFor="productImage"
                                  className="form-label"
                                >
                                  Product image <span className="text-danger">*</span></label>
                                <input
                                  className="form-control"
                                  type="file"
                                  id="productImage"
                                  name="productImage"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleFileChange(e, "productImage")
                                  }
                                />
                                {errors.productImage && (
                                  <div className="text-danger">
                                    {errors.productImage}
                                  </div>
                                )}
                              </div>
                              {selector.isEdit &&
                                Array.isArray(formData.productImage) &&
                                formData.productImage.map((imgObj, index) => (
                                  <div
                                    key={imgObj._id || index}
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                      margin: "5px",
                                    }}
                                  >
                                    <img
                                      src={
                                        imgObj instanceof File
                                          ? URL.createObjectURL(imgObj)
                                          : `${IMAGE_BASE_URL}${imgObj.docPath}/${imgObj.docName}`
                                      }
                                      alt={
                                        imgObj.originalName || "Product Image"
                                      }
                                      className="img-thumbnail"
                                      style={{ width: "50px", height: "50px" }}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => handleDeleteImage(index)}
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        background: "red",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                      }}
                                    >
                                      ×
                                    </button>
                                  </div>
                                ))}
                            </div>

                            <div className="col-lg-6">
                              <div className="mb-3">
                                <label
                                  htmlFor="additionalImages"
                                  className="form-label"
                                >
                                  Additional images
                                </label>
                                <input
                                  className="form-control"
                                  type="file"
                                  id="additionalImages"
                                  name="additionalImages"
                                  multiple
                                  onChange={(e) =>
                                    handleFileChange(e, "additionalImages")
                                  }
                                />
                              </div>
                              {selector.isEdit &&
                                Array.isArray(formData.additionalImages) &&
                                formData.additionalImages.map(
                                  (imgObj, index) => (
                                    <div
                                      key={imgObj._id || index}
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                        margin: "5px",
                                      }}
                                    >
                                      <img
                                        src={
                                          imgObj instanceof File
                                            ? URL.createObjectURL(imgObj)
                                            : `${IMAGE_BASE_URL}${imgObj.docPath}/${imgObj.docName}`
                                        }
                                        alt={
                                          imgObj.originalName ||
                                          "Additional Image"
                                        }
                                        className="img-thumbnail"
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleDeleteAdditionalImage(index)
                                        }
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          right: 0,
                                          background: "red",
                                          color: "white",
                                          border: "none",
                                          borderRadius: "50%",
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                          fontSize: "12px",
                                        }}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>
              */}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className='modal-footer mt-3'>
          {/* {errors.submit && (
            <div className="alert alert-danger py-2 px-3 mb-2 w-100 text-start" role="alert">
              {errors.submit}
            </div>
          )} */}
          <button

            type='button'
            className='form-wizard-next-btn btn btn-primary me-1 px-32'
            onClick={handleSubmit}
          >
            {isEditing ? "Update" : "Save"}
          </button>
          <button

            type='ffff'
            onClick={() => handleClose()}

            className='form-wizard-next-btn btn btn-secondary  px-32'
          >
            Cancel
          </button>

        </div>
      </div>
    </div>
  );
};

export default CreateProductListLayer;